import React, { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { TableCell, TableRow } from '@material-ui/core'

import { required } from '../common/objectUtils'

import { MyTableRowProps } from '../types/tableTypes'
import { CellAccessorFunc, CellValue, CellValueItem } from '../types/cellAccessor'

export const MyTableRow =
  observer(
    <TColumnId extends string, TRow extends object>
    ({table, visibleColumns, row}: MyTableRowProps<TColumnId, TRow>) => {
      const classes = useTableRowStyles()

      return <TableRow
        hover
        className={clsx('table-border', table.isRowSelected(row) && 'selected_row')}
        tabIndex={-1}
        selected={table.isRowSelected(row)}
        classes={{
          root: classes.tableRowRoot,
          selected: classes.tableRowSelected,
          hover: classes.hover
        }}
      >
        {
          visibleColumns.map(
            ({id, accessor, cellStyle, CellComponent}) =>
              CellComponent
              ? <CellComponent key={id} row={row} table={table} isSelected={table.isRowSelected(row)}/>
              :
              <TableCell
                key={id}
                className={clsx('table-border', table.isRowSelected(row) && 'selected_row')}
                style={typeof cellStyle === 'function' ? cellStyle(row) : cellStyle}
              >
                <span>{renderCellAccessor(row, accessor)}</span>
              </TableCell>
          )
        }
      </TableRow>
    })

const renderCellAccessor =
  <TRow extends object>(row: TRow, accessor: CellAccessorFunc<TRow>): ReactNode =>
    renderCellValue(required(accessor)(row))

const renderCellValue =
  (value: CellValue): ReactNode => {
    if (value instanceof Array) {
      // Render each item on a separate line
      return <>
        {value.map((item, index) => <div key={index}>{renderCellValueItem(item)}</div>)}
      </>
    }

    return renderCellValueItem(value)
  }

const renderCellValueItem =
  (value: CellValueItem): ReactNode => {
    if (typeof value === 'boolean') {
      return value ? 'Да' : 'Нет'
    }

    return value
  }

const useTableRowStyles = makeStyles(() => ({
  tableRowRoot: {
    '&$tableRowSelected, &$tableRowSelected:hover': {
      backgroundColor: '#E7F4FF'
    }
  },
  hover: {
    '&.MuiTableRow-hover:hover': {
      backgroundColor: '#E7F4FF'
    }
  },
  tableRowSelected: {
    backgroundColor: '#E7F4FF'
  }
}))